import { useState } from 'react';
import { Select, TextInput } from '@pella/sash-framework';

/**
 * Inline cell editor component for the DataGrid.
 * Renders either a Select or TextInput depending on field configuration.
 * @param {object} props - Component props
 * @param {string} props.id - Row ID
 * @param {unknown} props.value - Current cell value
 * @param {string} props.field - Column field name
 * @param {object} props.fullFiled - Full column definition object
 * @param {object} props.api - DataGrid API object
 * @param {object} props.row - Current row data
 * @param {string} props.parentId - Parent row ID
 * @param {() => void} [props.resetValues] - Optional callback to reset form values
 * @param {Array} [props.rows] - All rows data (used for computed valueOptions)
 */
const EditComponent = (props) => {
  const { id, value, field, fullFiled, api, row, parentId, resetValues, rows } = props;
  const [newValue, setNewValue] = useState(value);

  const saveUpdatedValue = async () => {
    api.setEditCellValue({ id, field, value: newValue });
    const temp = { ...row, [field]: newValue, parentId };
    await fullFiled.onRowUpdateModal(temp);
    if (typeof resetValues === 'function') {
      resetValues();
    }
  };

  const setInputValues = (e) => {
    setNewValue(e.target.value);
  };

  const checkEnterPress = (e) => {
    if (e.key === 'Enter') {
      saveUpdatedValue();
    }
  };

  const options = typeof fullFiled.valueOptions === 'function' ? fullFiled.valueOptions(rows) : fullFiled.valueOptions;

  return fullFiled.valueOptions ? (
    <Select
      id={`edit-${fullFiled.field}`}
      labelText={fullFiled.headerName || fullFiled.field}
      value={newValue || ''}
      onChange={setInputValues}
      onBlur={saveUpdatedValue}
    >
      {options.map((o) => (
        <option key={`${fullFiled.field}_${o.label || o}`} value={o.value !== undefined ? o.value : o}>
          {o.label || o}
        </option>
      ))}
    </Select>
  ) : (
    <TextInput
      id={`edit-${fullFiled.field}`}
      labelText={fullFiled.headerName || fullFiled.field}
      type={fullFiled.type === 'numeric' ? 'number' : 'text'}
      value={newValue || ''}
      onChange={setInputValues}
      onKeyDown={checkEnterPress}
      onBlur={saveUpdatedValue}
    />
  );
};

export default EditComponent;
